import { render, staticRenderFns } from "./applicationUsersTopbar.vue?vue&type=template&id=871d23e2"
import script from "./applicationUsersTopbar.vue?vue&type=script&lang=js"
export * from "./applicationUsersTopbar.vue?vue&type=script&lang=js"
import style0 from "./applicationUsersTopbar.vue?vue&type=style&index=0&id=871d23e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports